export enum NeoStatus {
  idle = '',
  initial = 'Initial',
  initialising = 'Initialising',
  loading = 'Loading',
  processing = 'Processing',
  error = 'Error',
}
